<template>
  <div>
    <span v-for="(value, index) in rates" :key="index">
      <el-tag style="height: auto" type="info">
        {{ $t('common_words.name') }}:
        {{
          value.activity_rate
            ? value.activity_rate.name
            : $t('common_words.no_assigned')
        }}
        <br />
        {{ $t('common_words.value') }}:
        {{ value.rate_value ? `$${formatNumber(value.rate_value)}` : 'N/A' }}
        <br />
        {{ $t('common_words.company') }}:
        {{ value.business ? value.business.name : 'N/A' }}
        <br />
        {{ $t('common_words.farm') }}:
        {{ value.farm ? value.farm.name : 'N/A' }}
        <br />
        {{ $t('common_words.allotment') }}:
        {{ value.lot ? value.lot.name : 'N/A' }}
      </el-tag>
    </span>
  </div>
</template>
<script>
import Formatter from 'src/class/Formatter';

export default {
  name: 'rate-types-info',
  props: {
    rates: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatNumber(value) {
      return Formatter.formatMoney(Number(value));
    },
  },
};
</script>
